import React, { useEffect, useRef, useState } from "react";
import { FaRegEdit, FaRegSave, FaTrash } from "react-icons/fa";
import * as RR from "react-redux";
import styled from "styled-components";
import ActionConfirmationButton from "../../../../../components/pages/CourseAuthor/ActionConfirmation";
import * as actions from "../../actions";
import AddOrg from "../AddOrg/AddOrg.component";

const ListName = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  gap: 2rem;
`;

const OrgNameContainer = styled.div<{ edit: boolean }>`
  border-bottom: 1px solid ${({ theme, edit }) => (edit ? theme.colors.menuBlueLight : theme.colors.lightgrey)};
  display: grid;
  gap: 2rem;
  grid-template-columns: minmax(200px, 1fr) 200px auto;
  grid-template-rows: 35px;
  overflow: hidden;
  min-width: 400px;

  & > div:last-child {
    display: flex;
    flex-flow: row nowrap;
    gap: 1rem;
  }
`;

const StyledInput = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  width: 100%;

  & > input {
    background-color: transparent;
    border: none;
    font-size: 1.6rem;
    width: 100%;
  }

  & > input:focus {
    outline: none;
  }
`;

interface IOrgListName {
  name: string;
  organizationId: string;
  isOrigin: boolean;
}

const OrgListName: React.FC<IOrgListName> = props => {
  const wrapperRef = useRef(null);
  const input = React.createRef<HTMLInputElement>();

  const dispatch = RR.useDispatch();

  const [editing, setEditing] = useState(false);

  const deleteOrganization = (): void => {
    dispatch(actions.deleteOrganizationFromPreview(props.organizationId));
  };

  const toEditing = () => {
    if (!props.isOrigin) {
      setEditing(true);
    }
    return;
  };

  const toNormal = (event: React.MouseEvent): void => {
    if (event.target === event.currentTarget) {
      setEditing(false);
    }
  };

  const handleSubmit = (): void => {
    if (!input.current) {
      return;
    }

    dispatch(
      actions.getOrgInfo({
        newOrganizationName: input.current.value,
        oldOrganizationName: props.name,
        organizationId: props.organizationId,
      })
    );

    setEditing(false);
  };

  const clickOutside = (ref: React.MutableRefObject<null>) => {
    useEffect(() => {
      const handleOutsideClick = (event: React.MouseEvent): void => {
        // @ts-ignore
        if (ref.current && !ref.current.contains(event.target)) {
          setEditing(false);
        }
      };

      // @ts-ignore
      document.addEventListener("mousedown", handleOutsideClick);
      return () => {
        // @ts-ignore
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    });
  };
  clickOutside(wrapperRef);

  const submit = (event: React.KeyboardEvent) => {
    event.preventDefault();
    if (event.key !== "Enter" || !input.current || input.current.value === "") {
      return;
    }

    if (input.current.value === props.name) {
      setEditing(false);
    }

    handleSubmit();
  };

  return (
    <OrgNameContainer edit={editing} onClick={toNormal} ref={wrapperRef}>
      {!editing ? (
        <ListName onClick={toEditing}>
          <span>{props.name}</span>
          {props.isOrigin && <FaRegEdit style={{ cursor: "pointer" }} />}
        </ListName>
      ) : (
        <StyledInput>
          <input
            ref={input}
            autoFocus={true}
            onKeyUp={submit}
            type={"text"}
            placeholder={props.name}
            defaultValue={props.name}
            spellCheck={false}
          />
          <FaRegSave style={{ cursor: "pointer" }} onClick={handleSubmit} />
        </StyledInput>
      )}
      <AddOrg owner={props.organizationId} />
      {props.isOrigin ? (
        <div style={{ width: "24px" }} />
      ) : (
        <ActionConfirmationButton action={"Delete"} actionFn={deleteOrganization} ActionIcon={FaTrash} />
      )}
    </OrgNameContainer>
  );
};

export default OrgListName;
